import APIService from './APIService';

export default {
  getUltimaDataBase(empresaId) {
    return APIService.apiCall().get(`laudos/get-ultima-data-base/${empresaId}`);
  }
};
